import { useEffect, useState } from 'react';

import { DontExistsItem } from '../../../components/DontExistsItem';
import { DontExistsItemFlex } from '../../../components/DontExistsItem/styles';
import { ListCardsExcludedCollect } from '../../../components/List/Collects/ListCardsExcludedCollect';
import { ListExcludedCollects } from '../../../components/List/ListExcludedCollect';
import { LoadingData } from '../../../components/LoadingData';
import { InfoExcludedCollect } from '../../../components/Modal/InfoExcludedCollect';
import { PageHeader, ViewMode } from '../../../components/PageHeader';
import { Paginator } from '../../../components/Paginator';
import { useExcludedCollectContext } from '../../../context/ProviderPage/Excluida';
import { usePageContext } from '../../../context/usePage';
import { ContainerPage, PageContent } from '../../../styles/global.styles';
import { Collect } from '../../../types/Collect';

const Excluida = () => {
  const { setSelectedPage } = usePageContext();
  const [modifyViewMode, setModifyViewMode] = useState<ViewMode>({
    have: true,
    mode: 'card',
  });
  const {
    loadExcludedCollectAction,
    loadingExcludedCollect,
    excludedCollect,
    openSideModalFilterExcludedCollectAction,
    setOfsset,
    limit,
    offset,
    quantity,
    page,
    setPage,
    setHasClick,
    start,
    setStart,
    openInfo,
    setOpenInfo,
  } = useExcludedCollectContext();

  useEffect(() => {
    setSelectedPage({ option: 'excluida' });
    loadExcludedCollectAction();
  }, []);

  return (
    <>
      <PageHeader
        {...{
          pageIcon: { option: 'excluida' },
          pageTitle: 'Canceladas',
          filterAction: openSideModalFilterExcludedCollectAction,
          modifyViewMode,
          setModifyViewMode,
        }}
      />

      <ContainerPage>
        <PageContent
          style={{
            justifyContent: `${
              loadingExcludedCollect === true ? 'center' : 'space-between'
            }`,
          }}
        >
          {loadingExcludedCollect ? (
            <LoadingData title="Buscando dados" />
          ) : (
            <>
              {excludedCollect.length === 0 ? (
                <DontExistsItemFlex>
                  <DontExistsItem title="Nenhuma região foi encontrada!" />
                </DontExistsItemFlex>
              ) : (
                <>
                  {modifyViewMode.mode === 'normal' ? (
                    <ListExcludedCollects data={excludedCollect} />
                  ) : (
                    <ListCardsExcludedCollect
                      data={excludedCollect as unknown as Collect[]}
                    />
                  )}
                  <Paginator
                    {...{
                      start,
                      setStart,
                      limitItens: limit,
                      offset,
                      page,
                      quantity,
                      setHasClick,
                      setOfsset,
                      setPage,
                      quantityShowed: excludedCollect.length,
                    }}
                  />
                </>
              )}
            </>
          )}
        </PageContent>
        <InfoExcludedCollect
          {...{
            option: 'excluida',
            titleModal: 'Coleta cancelada selecionada',
            isOpen: openInfo,
            closeModal: setOpenInfo,
          }}
        />
      </ContainerPage>
    </>
  );
};

export { Excluida };
